import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { MeResponse } from '@core/api/contracts';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CurrentUserApiClient {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = normalizeApiUrl(environment.apiUrl);

  getMe(): Observable<MeResponse> {
    return this.http.get<MeResponse>(`${this.apiUrl}/api/v1/me`, {
      headers: jsonHeaders(),
    });
  }
}

function normalizeApiUrl(apiUrl: string): string {
  return apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
}

function jsonHeaders(): HttpHeaders {
  return new HttpHeaders({
    Accept: 'application/json',
  });
}
